import { TOKEN } from "../config";
import { getFromStorage } from "../services/localStorage";

export const getAuthToken = () => {
  return getFromStorage(TOKEN) || "";
};
